import LegalLayout, { LegalSection } from "./LegalLayout";

const COOKIES = [
    { name: "access_token", purpose: "Session de connexion (jeton JWT)", duration: "Courte durée, renouvelé automatiquement" },
    { name: "refresh_token", purpose: "Maintien de la session sans ressaisir le mot de passe", duration: "Quelques jours" },
    { name: "impersonation_original", purpose: "Assistance technique : retour au compte administrateur", duration: "24 heures (administrateur uniquement)" },
];

export default function Cookies() {
    return (
        <LegalLayout title="Politique cookies" eyebrow="Traceurs et stockage local" lastUpdate="[À COMPLÉTER]">
            <LegalSection number="01" title="Cookies strictement nécessaires">
                <p>Profawz dépose uniquement les cookies indispensables au fonctionnement du service. Ils sont exemptés de consentement (article 82 de la loi Informatique et Libertés).</p>
                <table className="w-full text-sm border border-rule mt-3" data-testid="cookies-table">
                    <thead className="bg-ink text-white">
                        <tr><th className="text-left px-3 py-2">Nom</th><th className="text-left px-3 py-2">Finalité</th><th className="text-left px-3 py-2">Durée</th></tr>
                    </thead>
                    <tbody>
                        {COOKIES.map((c) => (
                            <tr key={c.name} className="border-t border-rule">
                                <td className="px-3 py-2 font-mono text-xs">{c.name}</td>
                                <td className="px-3 py-2">{c.purpose}</td>
                                <td className="px-3 py-2">{c.duration}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>Ces cookies sont <strong>httpOnly</strong> et <strong>Secure</strong> : ils ne sont pas lisibles par un script et ne circulent qu'en HTTPS.</p>
            </LegalSection>

            <LegalSection number="02" title="Stockage local du navigateur">
                <p>Certaines préférences d'affichage (filtres, dossiers ouverts, vue liste ou dossiers) sont mémorisées dans le stockage de session du navigateur. Elles ne quittent pas votre appareil et sont effacées à la fermeture de l'onglet.</p>
            </LegalSection>

            <LegalSection number="03" title="Mesure d'audience et services tiers">
                <p>Profawz n'utilise pas de cookie publicitaire. Aucun outil de mesure d'audience n'est activé dans l'application.</p>
                <p>Les polices de caractères sont chargées depuis Google Fonts : [À VÉRIFIER — envisager un hébergement local des polices pour éviter tout transfert d'adresse IP vers Google].</p>
            </LegalSection>

            <LegalSection number="04" title="Gérer les cookies">
                <p>Vous pouvez supprimer les cookies depuis les réglages de votre navigateur. La suppression des cookies de session entraîne simplement votre déconnexion.</p>
                <p>Questions : <strong>contact@profawz.fr</strong>.</p>
            </LegalSection>
        </LegalLayout>
    );
}
